import { render, staticRenderFns } from "./PersonalSpace-edit.vue?vue&type=template&id=1d77e354&"
import script from "./PersonalSpace-edit.vue?vue&type=script&lang=js&"
export * from "./PersonalSpace-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports